import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { IAumyeState } from '../states/aumye.state';

export function logger(
  reducer: ActionReducer<IAumyeState>
): ActionReducer<IAumyeState> {
  return (state: IAumyeState, action: any): any => {
    const result = reducer(state, action);
    console.groupCollapsed(action.type);
    console.log('Previous state', state);
    console.log('Action', action);
    console.log('Next state', result);
    console.groupEnd();

    return result;
  };
}

// export const metaReducers: MetaReducer<any>[] = [logger];
export const metaReducers: MetaReducer<any>[] = [];
export const aumyeReducer: ActionReducerMap<any, any> = {};
